angular.module('angus.services').service('gridState', 
	['$http', '$filter', 'moment', '_', 'fluentRest',
	function($http, $filter, moment, _, fluentRest) {
		'use strict';

		return function(subscriberId, widgetCode){
			return{
				get: function(){
					return fluentRest.api().subscribers(subscriberId).gridState(widgetCode).get();
				},
				save : function(state){	        	
		        	return fluentRest
		        		.api()
		        		.subscribers(subscriberId)
		        		.gridState(widgetCode)
		        		.put(state)
		        		.then(function(){
		        			return state;
		        		});
		        },
		        remove : function(){					        	
		        	return fluentRest
		        		.api()
		        		.subscribers(subscriberId)
		        		.gridState(widgetCode)
		        		.delete();
		        },
				createLegacyCopy : function(destinationUserId, sourceUserId, sourceSelectedWidgetCodes) {
					var params = {sourceUserId, sourceSelectedWidgetCodes};
					return $http.post((`api/internal/users/${destinationUserId}/grid-state-legacy/copy`), {},{params, apiV2: true})
						.then(function (res) {
							return res.data;
						});
				},
				getGridStateWidgetCodes: function(userId) {
					return $http.get((`api/internal/users/${userId}/grid-state-legacy/widget-codes`), {apiV2: true})
						.then(function (res) {
							return res.data;
						});
				},
	        }			  
		};	
	}
]);